/**
 * Icons im Feather-Stil, wie im Design-Prototyp: stroke-width 1.9–2.2,
 * abgerundete Enden, Größe über die Eigenschaft `groesse`.
 */

interface IconProps {
  groesse?: number;
  strich?: number;
  className?: string;
}

function Rahmen({
  groesse = 17,
  strich = 1.9,
  children,
  className,
}: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      width={groesse}
      height={groesse}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strich}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: 'block' }}
      className={className}
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

/** Meine Aufgaben – Sonne */
export const IconTag = (p: IconProps) => (
  <Rahmen {...p}>
    <circle cx="12" cy="12" r="4.2" />
    <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.5 1.5M16.9 16.9l1.5 1.5M18.4 5.6l-1.5 1.5M7.1 16.9l-1.5 1.5" />
  </Rahmen>
);

/** Kundenstammverwaltung – zwei Personen */
export const IconKunden = (p: IconProps) => (
  <Rahmen {...p}>
    <circle cx="9.5" cy="8.5" r="3.3" />
    <path d="M3.5 20c0-3.2 2.7-5.5 6-5.5s6 2.3 6 5.5" />
    <path d="M16.5 6.4a3 3 0 0 1 0 5.6" />
    <path d="M18 20c0-2.4-.8-4.2-2-5.2" />
  </Rahmen>
);

/** Service – Schraubenschlüssel */
export const IconWerkzeug = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M14.7 6.3a4 4 0 0 0-5.2 5.1L4 16.9V20h3.1l5.5-5.5a4 4 0 0 0 5.1-5.2l-2.6 2.6-2.4-2.4 2-3.2z" />
  </Rahmen>
);

/** sevDesk-Abgleich – zwei Kettenglieder */
export const IconVerknuepfung = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M10 13.5a4 4 0 0 0 5.7.3l2.6-2.6a4 4 0 0 0-5.7-5.7l-1.5 1.5" />
    <path d="M14 10.5a4 4 0 0 0-5.7-.3l-2.6 2.6a4 4 0 0 0 5.7 5.7l1.5-1.5" />
  </Rahmen>
);

/** Angebotsübersicht – Balken */
export const IconVertrieb = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M4 20V4" />
    <path d="M4 20h16" />
    <path d="M8 17v-5" />
    <path d="M13 17V8" />
    <path d="M18 17v-8" />
  </Rahmen>
);

/** Finanzen – Münze */
export const IconFinanzen = (p: IconProps) => (
  <Rahmen {...p}>
    <circle cx="12" cy="12" r="8.6" />
    <path d="M15.4 8.9a4 4 0 1 0 0 6.2" />
    <path d="M8.4 11.4h4.6M8.4 13.4h4.6" />
  </Rahmen>
);

/** Auftragsübersicht: unterschriebenes Dokument. */
export const IconAuftrag = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M6 3.4h7.6L18 7.8V20a.6.6 0 0 1-.6.6H6a.6.6 0 0 1-.6-.6V4a.6.6 0 0 1 .6-.6z" />
    <path d="M13.4 3.4v4.4H18" />
    <path d="M8.4 15.6c1.4-1.9 2.2-.4 3.2-1.4s1.4-2 2.2-1.1" />
  </Rahmen>
);

/** Sensibler Bereich */
export const IconSchloss = (p: IconProps) => (
  <Rahmen groesse={12} strich={2.2} {...p}>
    <rect x="4" y="10.5" width="16" height="10.5" rx="2.6" />
    <path d="M8 10.5V7.4a4 4 0 0 1 8 0v3.1" />
  </Rahmen>
);

export const IconProfil = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <circle cx="12" cy="8.5" r="3.6" />
    <path d="M5 20c0-3.4 3.1-5.8 7-5.8s7 2.4 7 5.8" />
  </Rahmen>
);

export const IconEinstellungen = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-2.9 1.2 2 2 0 1 1-4 0 1.7 1.7 0 0 0-2.9-1.2l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1A1.7 1.7 0 0 0 3 15a2 2 0 1 1 0-4 1.7 1.7 0 0 0 1.2-2.9l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.7 1.7 0 0 0 10 4.1a2 2 0 1 1 4 0 1.7 1.7 0 0 0 2.9 1.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1A1.7 1.7 0 0 0 21 11a2 2 0 1 1 0 4z" />
  </Rahmen>
);

export const IconAdmin = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M12 3l7.5 3v5.4c0 4.2-3 7.9-7.5 9.6-4.5-1.7-7.5-5.4-7.5-9.6V6z" />
    <path d="M9.4 12l1.9 1.9 3.4-3.6" />
  </Rahmen>
);

export const IconAbmelden = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M15 4h3.5A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5H15" />
    <path d="M10 8l-4 4 4 4" />
    <path d="M6 12h9" />
  </Rahmen>
);

export const IconBurger = (p: IconProps) => (
  <Rahmen groesse={18} strich={2.1} {...p}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Rahmen>
);

export const IconHaken = (p: IconProps) => (
  <Rahmen groesse={16} strich={2.2} {...p}>
    <path d="M5 12.5l4.5 4.5L19 7" />
  </Rahmen>
);

export const IconStift = (p: IconProps) => (
  <Rahmen groesse={14} {...p}>
    <path d="M4 20h4l10-10-4-4L4 16z" />
    <path d="M13.5 6.5l4 4" />
  </Rahmen>
);

export const IconSuche = (p: IconProps) => (
  <Rahmen groesse={16} {...p}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="M16 16l4 4" />
  </Rahmen>
);

export const IconTelefon = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M6.2 3.6h3l1.5 3.7-1.9 1.4a11.5 11.5 0 0 0 5.5 5.5l1.4-1.9 3.7 1.5v3a1.8 1.8 0 0 1-2 1.8A15.6 15.6 0 0 1 4.4 5.6a1.8 1.8 0 0 1 1.8-2z" />
  </Rahmen>
);

/** Papierflieger – „Angebot versendet". */
export const IconGesendet = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M20.5 3.5 10.8 13.2" />
    <path d="M20.5 3.5 14.3 20.5l-3.5-7.3-7.3-3.5z" />
  </Rahmen>
);

export const IconMail = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <rect x="3" y="5.5" width="18" height="13" rx="2.4" />
    <path d="M3.8 7l8.2 6 8.2-6" />
  </Rahmen>
);

export const IconInfo = (p: IconProps) => (
  <Rahmen groesse={15} strich={2} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5.2" />
    <path d="M12 7.6v.1" />
  </Rahmen>
);

export const IconWarnung = (p: IconProps) => (
  <Rahmen groesse={16} strich={2} {...p}>
    <path d="M12 4.2 21 19.5H3z" />
    <path d="M12 10v4" />
    <path d="M12 16.8v.1" />
  </Rahmen>
);

export const IconPfeilLinks = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M14 6l-6 6 6 6" />
  </Rahmen>
);

export const IconPfeilRechts = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M10 6l6 6-6 6" />
  </Rahmen>
);

export const IconHochladen = (p: IconProps) => (
  <Rahmen groesse={18} {...p}>
    <path d="M12 16V5" />
    <path d="M8 8.6 12 4.6l4 4" />
    <path d="M4.5 15.5v2.6A1.9 1.9 0 0 0 6.4 20h11.2a1.9 1.9 0 0 0 1.9-1.9v-2.6" />
  </Rahmen>
);

export const IconMuell = (p: IconProps) => (
  <Rahmen groesse={15} {...p}>
    <path d="M4.5 6.5h15" />
    <path d="M9 6.5V5a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 15 5v1.5" />
    <path d="M6.5 6.5 7.3 19a1.6 1.6 0 0 0 1.6 1.5h6.2a1.6 1.6 0 0 0 1.6-1.5l.8-12.5" />
  </Rahmen>
);

/** Verbesserungsvorschläge – Glühbirne */
export const IconGluehbirne = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M9.2 17.5h5.6" />
    <path d="M10 20.5h4" />
    <path d="M12 3.5a5.6 5.6 0 0 0-3.3 10.1c.5.4.8 1 .8 1.6v.3h5v-.3c0-.6.3-1.2.8-1.6A5.6 5.6 0 0 0 12 3.5Z" />
  </Rahmen>
);

/**
 * Montagekalender – ein Kalenderblatt (MONTAGEKALENDER.md 1.1).
 *
 * Bewusst nicht dasselbe Symbol wie die Outlook-Karte auf „Mein Tag": Dort
 * geht es um fremde Termine, hier um die eigenen Montagen.
 */
export const IconKalenderblatt = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M4.5 6.5h15v13h-15z" />
    <path d="M4.5 10.5h15" />
    <path d="M8.5 3.5v4" />
    <path d="M15.5 3.5v4" />
    <path d="M8.5 14h3" />
  </Rahmen>
);

/** Buchhaltungsvorbereitung – Beleg */
export const IconBeleg = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M5.5 3.5h13v17l-2.2-1.5-2.1 1.5-2.2-1.5-2.2 1.5-2.1-1.5-2.2 1.5Z" />
    <path d="M9 8h6" />
    <path d="M9 12h6" />
  </Rahmen>
);

/**
 * Der Vorgangsordner auf dem PC – gelber Windows-Ordner (v14, 17.7).
 *
 * Eine bewusste Ausnahme von „Gelb heißt Aktion": Der Absprung in den
 * Ordner ist eine. Und der Ordner ist seit 24.09.2026 der einzige Weg zu
 * den Dateien eines Vorgangs – die früheren Absprünge in fremde Systeme
 * sind entfallen, deshalb darf dieses eine Symbol auffallen.
 *
 * `grau` heißt: Der Ordner ist noch nicht angelegt.
 */
export function IconWindowsOrdner({ groesse = 18, grau = false }: { groesse?: number; grau?: boolean }) {
  return (
    <svg
      width={groesse}
      height={Math.round((groesse * 16) / 18)}
      viewBox="0 0 24 20"
      aria-hidden="true"
      style={{ display: 'block' }}
    >
      <path
        d="M1 3a2 2 0 0 1 2-2h6l2 2h10a2 2 0 0 1 2 2v2H1z"
        fill={grau ? 'var(--eh-punkt-erledigt)' : 'var(--eh-aktion-hover)'}
      />
      <path
        d="M1 7h22v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z"
        fill={grau ? 'var(--eh-rahmen-schalter)' : 'var(--eh-aktion)'}
      />
    </svg>
  );
}

/**
 * Ordner als Umriss – für Links im Fließtext und in Menüs.
 *
 * Einfarbig in der Textfarbe: Dort soll der Link als Link erkennbar sein,
 * nicht als Schaltfläche. Die gefüllte gelbe Form steht in der Liste.
 */
export function IconOrdner({ groesse = 15 }: { groesse?: number }) {
  return (
    <svg
      width={groesse}
      height={groesse}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ display: 'block' }}
    >
      <path d="M3 7a2 2 0 0 1 2-2h4l2 2.5h8a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
    </svg>
  );
}

/**
 * Privatperson – Kopf und Schultern.
 *
 * Ersetzt den gefüllten Kreis der alten Kundenliste. Ein Kreis heißt für
 * niemanden „Privatperson"; man musste es sich merken oder in der Legende
 * nachsehen. Eine Person heißt Person.
 */
export const IconPerson = (p: IconProps) => (
  <Rahmen {...p}>
    <circle cx="12" cy="8" r="3.6" />
    <path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6" />
  </Rahmen>
);

/**
 * Organisation – ein einfaches Gebäude.
 *
 * Ersetzt das Vierfelder-Raster, das ebenso erklärungsbedürftig war. Die
 * Fenster im Haus sind bewusst nur angedeutet: Bei 22 Pixeln wird jedes
 * weitere Detail zum Fleck.
 */
export const IconGebaeude = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M4 20V6.5a1.5 1.5 0 0 1 1.5-1.5h9A1.5 1.5 0 0 1 16 6.5V20" />
    <path d="M16 11h2.5A1.5 1.5 0 0 1 20 12.5V20" />
    <path d="M2.5 20h19" />
    <path d="M7.5 9h1.5M11 9h1.5M7.5 13h1.5M11 13h1.5" />
  </Rahmen>
);

/**
 * sevDesk – ein Beleg mit Eurozeichen.
 *
 * Kein Markenlogo: Die anderen Absprünge tragen ihres, sevDesk stellt keines
 * bereit, und ein nachgezeichnetes wäre falscher als ein sprechendes Symbol.
 * Gemeint ist ohnehin nicht die Marke, sondern was dort entsteht – die
 * Rechnung.
 */
export const IconRechnung = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M6 3.5h12a1 1 0 0 1 1 1V21l-2.5-1.6L14 21l-2.5-1.6L9 21l-2.5-1.6L4 21V4.5a1 1 0 0 1 1-1Z" />
    <path d="M14.6 9.4a2.9 2.9 0 0 0-4.6 2.3 2.9 2.9 0 0 0 4.6 2.3" />
    <path d="M8.9 11h3.4" />
  </Rahmen>
);

/* ---- Kacheln von „Mein Tag" (v6) ------------------------------------------ */

/** Kalkulieren – Rechner */
export const IconRechner = (p: IconProps) => (
  <Rahmen {...p}>
    <rect x="5" y="3" width="14" height="18" rx="2" />
    <path d="M8.5 7h7" />
    <path d="M8.5 11.5h.01M12 11.5h.01M15.5 11.5h.01M8.5 15h.01M12 15h.01M15.5 15v3M8.5 18h.01M12 18h.01" />
  </Rahmen>
);

/** Beschaffung – Paket */
export const IconPaket = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M12 3 20 7.2v9.6L12 21l-8-4.2V7.2z" />
    <path d="M4 7.2 12 11.4l8-4.2" />
    <path d="M12 11.4V21" />
    <path d="M8 5.1l8 4.2" />
  </Rahmen>
);

/** Lieferung & Montage – Lkw */
export const IconLkw = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M3 6.5h10v9H3z" />
    <path d="M13 9.5h4.2L21 13v2.5h-8" />
    <circle cx="7" cy="17.5" r="1.8" />
    <circle cx="17" cy="17.5" r="1.8" />
  </Rahmen>
);

/** Wiedervorlage – Uhr */
export const IconUhr = (p: IconProps) => (
  <Rahmen {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 2" />
  </Rahmen>
);

/** Farben meiner Rubriken – Palette */
export const IconPalette = (p: IconProps) => (
  <Rahmen {...p}>
    <path d="M12 3.2c-4.8 0-8.6 3.5-8.6 7.9 0 4.3 3.4 6.6 6.2 6.6 1.6 0 2.2-.9 2.2-1.8 0-.9-.8-1.3-.8-2.2 0-.8.7-1.4 1.6-1.4h1.9c3 0 5.3-2 5.3-4.9 0-2.6-2.7-4.2-7.8-4.2Z" />
    <circle cx="7.4" cy="10.6" r="1" />
    <circle cx="11" cy="7.6" r="1" />
    <circle cx="15.2" cy="8.6" r="1" />
  </Rahmen>
);
